module.exports = __webpack_public_path__ + "static/img/wood62.22d85d0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wood62.jpg
// module id = YKxN
// module chunks = 0